const prod = {
    url: {
        API_URL: 'https://greenium.com.br/api/public',
        NEST_URL: 'https://greenium-back.greenium.com.br'
    }
};
const dev = {
    url: {
        API_URL: 'http://localhost/Greenium_Legado/api/public',
        NEST_URL: 'http://localhost:3000'
        // API_URL: 'https://greenium.com.br/api/public',
    }
};

export const config = process.env.NODE_ENV === 'development' ? prod : prod;